import React, { useContext, useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { ADMIN_CONSOLE_LINKS, ADMIN_CONSOLE_NAV, ADMIN_SYSTEM_NAV } from './adminNav';
import AuthContext from '../shared/AuthContext';
import { isSystemAdmin } from '../../utils/platformRoles';
import './adminConsole.css';

export default function AdminConsoleNav() {
  const { user } = useContext(AuthContext);
  const profile = useMemo(() => {
    try {
      return user || JSON.parse(localStorage.getItem('userProfile') || 'null');
    } catch {
      return user;
    }
  }, [user]);

  const primaryNav = useMemo(() => {
    const items = [...ADMIN_CONSOLE_NAV];
    if (isSystemAdmin(profile)) {
      items.push(...ADMIN_SYSTEM_NAV);
    }
    return items;
  }, [profile]);

  return (
    <nav className="admin-console-nav" aria-label="Admin console sections">
      <div className="admin-console-nav-primary">
        {primaryNav.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.end}
            className={({ isActive }) =>
              `admin-console-nav-link${isActive ? ' admin-console-nav-link--active' : ''}`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </div>
      <div className="admin-console-nav-divider" aria-hidden />
      <div className="admin-console-nav-secondary">
        {ADMIN_CONSOLE_LINKS.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `admin-console-nav-link admin-console-nav-link--secondary${
                isActive ? ' admin-console-nav-link--active' : ''
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
